module.exports = __webpack_public_path__ + "static/media/sidebar-bg.70d85cca.png";